import { Navigate, useLocation } from 'react-router-dom';
import { useSubscription } from '@/hooks/useSubscription';
import ProtectedRoute from '@/components/ProtectedRoute';
import { RouteGateFallback } from '@/components/routing/RouteGateFallback';
import { getUpgradePath } from '@/utils/upgradeRoute';

interface SubscriptionRequiredRouteProps {
  children: React.ReactNode;
}

function SubscriptionRequiredRouteInner({ children }: SubscriptionRequiredRouteProps) {
  const location = useLocation();
  const { hasPremiumAccess, isLoadingSubscription } = useSubscription();

  if (isLoadingSubscription) {
    return <RouteGateFallback />;
  }

  if (!hasPremiumAccess) {
    const redirectPath = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={getUpgradePath(redirectPath)} replace />;
  }

  return <>{children}</>;
}

const SubscriptionRequiredRoute = ({ children }: SubscriptionRequiredRouteProps) => (
  <ProtectedRoute>
    <SubscriptionRequiredRouteInner>{children}</SubscriptionRequiredRouteInner>
  </ProtectedRoute>
);

export default SubscriptionRequiredRoute;
